module.exports = window["MaterialUI"].SwipeableDrawer;